"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Loader = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'loader'
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Loading, {
    withOverlay: true
  }));
};
var _default = exports.default = Loader;